module.exports = __webpack_public_path__ + "img/img-a46218e4.14b5ded5.png";